var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorreo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26039",
    "data-name": "Rect\\xE1ngulo 26039",
    width: 25,
    height: 25,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Correo",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24813",
    "data-name": "Trazado 24813",
    d: "M25.185,13.281a11.9,11.9,0,1,1-11.9-11.9,11.9,11.9,0,0,1,11.9,11.9",
    transform: "translate(-0.78 -0.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24814",
    "data-name": "Trazado 24814",
    d: "M12.5,25A12.5,12.5,0,1,1,25,12.5,12.514,12.514,0,0,1,12.5,25m0-23.809A11.309,11.309,0,1,0,23.808,12.5,11.321,11.321,0,0,0,12.5,1.191",
    transform: "translate(0 0)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24815",
    "data-name": "Trazado 24815",
    d: "M31.612,19.789H21.529A1.311,1.311,0,0,0,20.22,21.1v5.681a1.311,1.311,0,0,0,1.309,1.309H31.612a1.311,1.311,0,0,0,1.309-1.309V21.1a1.311,1.311,0,0,0-1.309-1.309m.417,6.99a.417.417,0,0,1-.417.417H21.529a.417.417,0,0,1-.417-.417V21.1a.417.417,0,0,1,.417-.417H31.612a.417.417,0,0,1,.417.417Z",
    transform: "translate(-11.469 -11.225)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24816",
    "data-name": "Trazado 24816",
    d: "M31.591,26.174l1.74-1.532a.446.446,0,1,0-.589-.67l-3.969,3.494-3.91-3.492a.446.446,0,0,0-.594.665L26.01,26.2l-1.74,1.532a.446.446,0,0,0,.589.67l1.821-1.6,1.792,1.6a.446.446,0,0,0,.592,0l1.852-1.63L32.738,28.4a.446.446,0,1,0,.595-.665Z",
    transform: "translate(-13.681 -13.535)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24817",
    "data-name": "Trazado 24817",
    d: "M11.105,23.69V25.8l-4.978-.777Z",
    transform: "translate(-3.476 -13.437)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24818",
    "data-name": "Trazado 24818",
    d: "M11.105,29.966v2.106l-4.978-.777Z",
    transform: "translate(-3.476 -16.997)",
    fill: "#d5007f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorreo);
export default __webpack_public_path__ + "static/media/Correo.0044badae070845043881e267e3e44f9.svg";
export { ForwardRef as ReactComponent };